import {
  Card,
  CardContent,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { SEVERITY_LEVELS, SeverityLevel } from "@/models/report";
import { FormLabel } from "./FormLabel";

interface SeverityCardProps {
  severity: string;
  onSeverityChange: (value: string) => void;
}

export function SeverityCard({
  severity,
  onSeverityChange,
}: SeverityCardProps) {
  const { t } = useTranslation();

  const getColors = (level: string, isSelected: boolean) => {
    const isCritical = level === SeverityLevel.Critical;
    return {
      borderColor: isSelected
        ? isCritical
          ? "error.main"
          : "primary.main"
        : "divider",
      bgcolor: isSelected
        ? isCritical
          ? "error.main"
          : "primary.main"
        : "transparent",
      hoverBorderColor: isCritical ? "error.main" : "primary.main",
    };
  };

  return (
    <Card>
      <CardContent>
        <FormLabel label={t("form.severity")} required />
        <RadioGroup
          value={severity}
          onChange={(e) => onSeverityChange(e.target.value)}
        >
          <Grid container spacing={1} sx={{ mt: 0.5 }}>
            {SEVERITY_LEVELS.map((level) => {
              const isSelected = severity === level;
              const colors = getColors(level, isSelected);
              return (
                <Grid size={6} key={level}>
                  <Box
                    sx={{
                      border: "1px solid",
                      borderColor: colors.borderColor,
                      borderRadius: 2,
                      px: 1.5,
                      py: 0.5,
                      bgcolor: colors.bgcolor,
                      transition: "all 0.2s",
                      cursor: "pointer",
                      "&:hover": { borderColor: colors.hoverBorderColor },
                    }}
                    onClick={() => onSeverityChange(level)}
                  >
                    <FormControlLabel
                      value={level}
                      control={<Radio size="small" sx={{ display: "none" }} />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                            color: isSelected ? "#fff" : "text.primary",
                          }}
                        >
                          {t(`severity.${level}`)}
                        </Typography>
                      }
                      sx={{ m: 0, width: "100%", justifyContent: "center" }}
                    />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </RadioGroup>
      </CardContent>
    </Card>
  );
}
